module.exports = __webpack_public_path__ + "static/img/45.1aff237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/45.png
// module id = 4bGg
// module chunks = 0